import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'

export interface SilentReauthResponse {
  accessJwt: string
  refreshJwt: string
  did: string
  handle: string
}

export async function silentReauth(
  _agent: BskyAgent,
  reauthJwt: string,
  options?: {signal?: AbortSignal},
): Promise<SilentReauthResponse> {
  return wsocFetch<SilentReauthResponse>(
    xrpcPath('eu.wsocial.quicklogin.silentReauth'),
    {body: {reauthJwt}, signal: options?.signal},
  )
}
